export { default } from './HeaderAuthSlot';
